export const TerminalIconRound = {
  0: {
    4: require('@/views/dashboard/_images/terminal-icon-round/quit.png'),
  },
  1: {
    1: require('@/views/dashboard/_images/terminal-icon-round/win-online.png'),
    2: require('@/views/dashboard/_images/terminal-icon-round/win-offline.png'),
    4: require('@/views/dashboard/_images/terminal-icon-round/quit.png'),
  },
  2: {
    1: require('@/views/dashboard/_images/terminal-icon-round/linux-online.png'),
    2: require('@/views/dashboard/_images/terminal-icon-round/linux-offline.png'),
    4: require('@/views/dashboard/_images/terminal-icon-round/quit.png'),
  },
  3: {
    1: require('@/views/dashboard/_images/terminal-icon-round/win-server-online.png'),
    2: require('@/views/dashboard/_images/terminal-icon-round/win-server-offline.png'),
    4: require('@/views/dashboard/_images/terminal-icon-round/quit.png'),
  },
  4: {
    1: require('@/views/dashboard/_images/terminal-icon-round/mac-online.png'),
    2: require('@/views/dashboard/_images/terminal-icon-round/mac-offline.png'),
    4: require('@/views/dashboard/_images/terminal-icon-round/quit.png'),
  }
}
